import React from "react";
import FormTable from "./formTable";

export default function (initialValue = {}) {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden",
        initialValue: initialValue.id,
      },
    },
    {
      title: "参训统计名称",
      name: "name",
      formItem: {
        maxLength: 40,
        placeholder: "名称最多输入40个字",
        initialValue: initialValue.name,
        rules: [
          {
            required: true,
            message: "请输入名称",
          },
        ],
      },
    },
    {
      title: "统计方式",
      name: "bizType",
      formItem: {
        type: "select",
        initialValue: initialValue.bizType || 1,
        disabled: this.isUpd ? true : false
      },
      dict: [
        { code: 1, codeName: "单个统计" },
        { code: 2, codeName: "组合统计" },
      ],
    },
    {
      title: "状态",
      name: "status",
      formItem: {
        initialValue: !initialValue.status && initialValue.status !== 0 ? 1 : initialValue.status,
        type: "radio",
      },
      dict: [
        { code: 1, codeName: "有效" },
        { code: 0, codeName: "无效" },
      ],
    },
    {
      title: "统计信息",
      name: "entityList",
      formItem: {
        rules: [
          {
            required: true,
            message: "请选择统计信息",
          },
        ],
        type: "diy",
        initialValue: initialValue.entityList,
        links:'bizType',
        diy: ({ linksValues, onChange, value }) => <FormTable linksValues={linksValues} value={initialValue.entityList} onChange={onChange} />
      },
    },
  ];
}
